import React, { useState } from 'react'
import styled from 'styled-components'
import { Box } from 'pcln-design-system'
import { BestPriceGuaranteeCard, ModalHandler } from '@pcln/fly-ui-components'
import { ModalHeader } from 'pcln-modal'

const StyledIFrame = styled.iframe`
  height: 760px;
  padding: 10px;
  width: 100%;

  ${(props) => props.theme.flyQueries.desktop} {
    width: 760px;
  }
`

const iframeUrl = 'https://www.priceline.com/landing/best-price-guarantee.htm?&lrdr=secure'

function BestPriceGuarantee(props) {
  const { showBPGOverlay = false } = props
  const [isVisible, setIsVisible] = useState(showBPGOverlay)

  const hideOverlay = () => setIsVisible(false)
  const showOverlay = () => setIsVisible(true)

  return (
    <>
      {isVisible ? (
        <ModalHandler
          width='760px'
          imgMode={true}
          isStatic
          disableCloseButton
          onClose={hideOverlay}
          header={<ModalHeader title={'Best Price Guarantee'} />}
        >
          <StyledIFrame src={iframeUrl} />
        </ModalHandler>
      ) : null}
      <Box mb={'24px'}>
        <BestPriceGuaranteeCard whenClicked={showOverlay} ariaLabel='Best Price Guaranteed Information' />
      </Box>
    </>
  )
}

export { BestPriceGuarantee }
